<section *transloco="let t; read: 'configurations.overview'" class="configuration-overview__group">
  @if (isConfigLoading()) {
    <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }
  <div class="configuration-overview__section-title">
    <h5>{{ t('header') }}</h5>
    <p>{{ t('content') }}</p>
  </div>
  <div class="configuration-overview__metadata-wrapper">
    <div class="configuration-overview__metadata-table">
      <div class="configuration-overview__row">
        <div class="configuration-overview__label">{{ t('id') }}</div>
        <div class="configuration-overview__config-id">
          <div>{{ configuration()?.id }}</div>

          <xi-icon-button
            icon="copy"
            [tooltip]="{ text: t('copy-tooltip') }"
            (click)="copyConfigId()"
            color="CX"
          ></xi-icon-button>
        </div>
      </div>
      <div class="configuration-overview__row">
        <div class="configuration-overview__label">{{ t('descended-from') }}</div>
        <div>{{ ancestorConfiguration?.name }}</div>
      </div>

      <div class="configuration-overview__row">
        <div class="configuration-overview__label">{{ t('based-on') }}</div>
        <div>{{ templateConfiguration()?.name }}</div>
      </div>

      <div class="configuration-overview__row">
        <div class="configuration-overview__label">{{ modificationLabel }}:</div>
        <div class="xi-loader-button-container">
          @if (!configVersionLoading) {
            <div>
              {{ modificationDate | lexDate: 'long' }}
            </div>
          }
          @if (configVersionLoading) {
            <div class="configuration-overview__inline-loader-container">
              <xi-animation
                [height]="75"
                [width]="75"
                [loop]="true"
                animation="cx_loader"
              ></xi-animation>
            </div>
          }
        </div>
      </div>

      <div class="configuration-overview__row">
        <div class="configuration-overview__label">{{ t('version') }}</div>

        <div class="xi-loader-button-container">
          @if (!configVersionLoading) {
            <div>
              {{ configVersion }} {{ t('as-of') }} {{ configLastCheckedDate | lexDate: 'long' }}
            </div>
          }
          @if (configVersionLoading) {
            <div class="configuration-overview__inline-loader-container">
              <xi-animation
                [height]="75"
                [width]="75"
                [loop]="true"
                animation="cx_loader"
              ></xi-animation>
            </div>
          }
        </div>
      </div>

      <div class="configuration-overview__row">
        <div class="configuration-overview__label">{{ t('last-used') }}</div>
        <div>{{ configuration()?.last_processing_date | lexDate: 'long' }}</div>
      </div>

      <div class="configuration-overview__row">
        <div class="configuration-overview__label">{{ t('created-by') }}</div>
        <div>{{ createdBy }}</div>
      </div>
    </div>
  </div>
</section>
